import { businessKey } from 'queryKeys';

const LAST_ACTIVITY = 'lastActivity';
const laQuery = businessKey.query(LAST_ACTIVITY);

export const results = laQuery.grid();

export const mutations = laQuery.mutations();

export const update = mutations.update();
